import { UrlObject } from 'url'

export const queryParams = {
  email: 'email',
}

export const pathConstructor = {
  index: (email: string): UrlObject => ({
    pathname: '/reset-password/sent',
    query: {
      [queryParams.email]: email,
    },
  }),
}
